import { AgeingResponse, CreditStandingResponse, FinanceEntriesResponse, FinanceEntryListResponse, FinanceEntryResponse, } from '@aeris/contracts';
import { request } from "./client.js";
const financeParams = (query) => {
    const params = new URLSearchParams();
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    if (query.status !== undefined)
        params.set('status', query.status);
    // A URL carries text, and the server reads the literal 'true'/'false'.
    if (query.overdueOnly !== undefined) {
        params.set('overdueOnly', query.overdueOnly ? 'true' : 'false');
    }
    if (query.partyId !== undefined)
        params.set('partyId', query.partyId);
    if (query.dueFrom !== undefined)
        params.set('dueFrom', query.dueFrom);
    if (query.dueTo !== undefined)
        params.set('dueTo', query.dueTo);
    if (query.search !== undefined && query.search.length > 0) {
        params.set('search', query.search);
    }
    if (query.offset !== undefined)
        params.set('offset', String(query.offset));
    if (query.limit !== undefined)
        params.set('limit', String(query.limit));
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.order !== undefined)
        params.set('order', query.order);
    const encoded = params.toString();
    return encoded.length > 0 ? `?${encoded}` : '';
};
export const fetchFinanceEntries = async (query, signal) => FinanceEntryListResponse.parse(await request(`/api/v1/finance/entries${financeParams(query)}`, { signal }));
export const fetchFinanceEntry = async (id, signal) => FinanceEntryResponse.parse(await request(`/api/v1/finance/entries/${id}`, { signal }));
export const fetchAgeing = async (direction, signal) => AgeingResponse.parse(await request(`/api/v1/finance/ageing?direction=${direction}`, { signal }));
export const createFinanceEntry = async (input) => FinanceEntriesResponse.parse(await request('/api/v1/finance/entries', { method: 'POST', body: input }));
export const settleFinanceEntry = async (id, input) => FinanceEntryResponse.parse(await request(`/api/v1/finance/entries/${id}/settle`, {
    method: 'POST',
    body: input,
}));
/** Várias formas de uma vez, numa transação só: o acerto dividido (F161). */
export const settleFinanceEntrySplit = async (id, input) => FinanceEntryResponse.parse(await request(`/api/v1/finance/entries/${id}/settle-split`, {
    method: 'POST',
    body: input,
}));
export const reverseFinanceSettlement = async (entryId, settlementId, input) => FinanceEntryResponse.parse(await request(`/api/v1/finance/entries/${entryId}/settlements/${settlementId}/reverse`, { method: 'POST', body: input }));
export const fetchCredit = async (partyId, signal) => CreditStandingResponse.parse(await request(`/api/v1/finance/credit/${partyId}`, { signal }));
export const setCredit = async (partyId, input) => CreditStandingResponse.parse(await request(`/api/v1/finance/credit/${partyId}`, {
    method: 'PATCH',
    body: input,
}));
export const cancelFinanceEntry = async (id, input) => FinanceEntryResponse.parse(await request(`/api/v1/finance/entries/${id}/cancel`, {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=finance.js.map